import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on every route change (unless navigating to an in-page hash).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}
